import { pushToDataLayer } from '@almbrand/trackinghooks';
import { TileComponentProps } from 'components/2-molecules/TileComponent';

/**
 * Utility function for tracking tiles container view events in GTM
 * @param component - The content API model containing tile data
 */
export const trackTilesList = (component: ContentApiModel, brand: Theme) => {
	const { content } = component ?? {};

	// Track tiles container view event
	if (content?.mainArea?.items && content.mainArea.items.length > 0) {
		// Clear the previous ecommerce object
		pushToDataLayer({ ecommerce: null });

		// Build items array from content data using TileComponentProps structure
		const items = content.mainArea.items.map((item, index) => {
			const tileProps = item.content as TileComponentProps;

			return {
				item_id: tileProps.contentId?.toString() || `tile-${index}`,
				item_name: tileProps.title || `Tile ${index + 1}`,
				affiliation: 'online',
				index: index,
				item_brand: brand,
				item_category: 'Insurance',
				item_category2: tileProps.title,
				item_list_id: content.contentId?.toString() || 'tiles-container',
				item_list_name: content.contentName,
				quantity: 1,
			};
		});

		// Push the view_item_list event
		pushToDataLayer({
			event: 'view_item_list',
			ecommerce: {
				item_list_id: content.contentId?.toString() || 'tiles-container',
				item_list_name: content.contentName,
				items: items,
			},
		});
	}
};
